import { finalizeBasket, selectBasketContracts } from 'containers/OrderDetails/basketSlice'
import { selectUser } from 'containers/Login/loginSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import DetailsSlide from './DetailsSlide'
import Loading from 'components/Loading'
import FirstSlide from './FirstSlide'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'
import PinSlide from './PinSlide'
import './style.scss'


// const contract = {
//   "locks": [
//     {
//       "warehouseId": "9c001ee4-7516-42c4-8056-dfb99e610278",
//       "warehouseNumber": "1",
//       "warehouseAdress": "Pabianice, ul. Grota 1",
//       "pages": [
//         {
//           "sections": [
//             {
//               "title": "Jak otworzyć bramę do placu?",
//               "content": "Brama otwiera się z aplikacji lub z panelu wjazdowego znajudjącego się obok bramy, gdzie naley wpisać numer telefonu i swój pin do aplikacji",
//               "type": "text"
//             },
//             {
//               "title": "Twój pin do aplikacji i bramy",
//               "content": "xxxx",
//               "type": "pin"
//             }
//           ]
//         },
//         {
//           "sections": [
//             {
//               "title": "Jak otworzyć magazyn na placu?",
//               "content": "Twój magazyn aktualnie nie jest zabezpieczony. Musisz uzyc kłódki",
//               "type": "text"
//             },
//             {
//               "title": "skąd wziąć kłódkę?",
//               "content": "{dane dostawy}",
//               "type": "text"
//             }
//           ]
//         }
//       ]
//     },
//     {
//       "warehouseId": "9c001ee4-7516-42c4-8056-dfb99e610218",
//       "warehouseNumber": "2",
//       "warehouseAdress": "Pabianice, ul. Grota 2",
//       "pages": [
//         {
//           "sections": [
//             {
//               "title": "Jak otworzyć bramę do placu?",
//               "content": "Brama otwiera się z aplikacji lub z panelu wjazdowego znajudjącego się obok bramy, gdzie naley wpisać numer telefonu i swój pin do aplikacji",
//               "type": "text"
//             },
//             {
//               "title": "Twój pin do aplikacji i bramy",
//               "content": "xxxx",
//               "type": "pin"
//             }
//           ]
//         },
//         {
//           "sections": [
//             {
//               "title": "Jak otworzyć magazyn na placu?",
//               "content": "Twój magazyn aktualnie nie jest zabezpieczony. Musisz uzyc kłódki",
//               "type": "text"
//             },
//             {
//               "title": "skąd wziąć kłódkę?",
//               "content": "{dane dostawy}",
//               "type": "text"
//             }
//           ]
//         }
//       ]
//     }
//   ]
// }

// const contracts = [{ id: 'a1c3a0bd-6c2e-491b-934b-1a8cfff19e2d' }]
const NewWarehouse = () => {
  const user = useSelector(selectUser)
  const contracts = useSelector(selectBasketContracts)

  const [data, setData] = useState(undefined)
  const [isLoading, setLoading] = useState(false)
  const [firstSlideVisible, setFirstSlideVisible] = useState(true)
  const currentFirstSlideVisible = useRef(firstSlideVisible)
  currentFirstSlideVisible.current = firstSlideVisible

  const thereIsPin = !!user?.pin
  const pinSlideVisible = thereIsPin
    ? false
    : data?.locks?.some(lock => lock.isPinRequired)

  const dispatch = useDispatch()
  const { replace } = useHistory()
  const fetchContracts = async (ids, errorCallback) => {
    setLoading(true)
    try {
      const response = await POST(urls.contracts, { body: { ids } })
      if (Array.isArray(response?.locks) && !response.locks.some(lock => lock.error)) {
        setData(response)
        setLoading(false)
      } else {
        throw new Error('Wrong response')
      }
    } catch (error) {
      setLoading(false)
      errorCallback?.()
    }
  }

  useEffect(() => {
    const thereAreContractList = Array.isArray(contracts)
    if (!thereAreContractList || contracts.length === 0) {
      if (!thereAreContractList) {
        replace('/warehouses')
      }
      return
    }

    const errorCallback = () => {
      if (!currentFirstSlideVisible.current) {
        replace('/warehouses')
        dispatch(finalizeBasket())
      }
    }

    fetchContracts(contracts.map(c => c.id), errorCallback)
  }, [contracts, dispatch, replace])

  return (
    <section className='newWarehouse --animated'>
      <div className='slides'>
        {firstSlideVisible
          ? <FirstSlide
            nextPage={() => {
              if (Array.isArray(contracts) && contracts.length > 0 && (isLoading || data)) {
                setFirstSlideVisible(false)
              } else {
                dispatch(finalizeBasket())
                replace('/warehouses')
              }
            }}
          />
          : isLoading
            ? <Loading />
            : pinSlideVisible
              ? <PinSlide
                callback={() => {
                  fetchContracts(contracts.map(c => c.id))
                }}
              />
              : <DetailsSlide
                locks={data?.locks}
                back={() => {
                  setFirstSlideVisible(true)
                }}
              />
        }
      </div>
    </section>
  )
}

export default NewWarehouse